import * as React from "react";
import type { SVGProps } from "react";
const SvgVolumeMute = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.32 20.624c.27.154.578.236.89.236q.15.005.3-.02A1.79 1.79 0 0 0 12 18.86V5a1.79 1.79 0 0 0-1-1.8 1.84 1.84 0 0 0-2.33.73l-3.16 4H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h1.51l3.15 4.05c.16.268.388.49.66.644M4 13.93v-4h2a1 1 0 0 0 .79-.39L10 5.44v13l-3.21-4.12a1 1 0 0 0-.79-.39z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M19.616 14.856a1 1 0 0 0 .384.074 1 1 0 0 0 .71-1.71l-1.3-1.29 1.3-1.29a1.004 1.004 0 1 0-1.42-1.42L18 10.52l-1.29-1.3a1.004 1.004 0 1 0-1.42 1.42l1.3 1.29-1.3 1.29a1.004 1.004 0 1 0 1.42 1.42l1.29-1.3 1.29 1.3a1 1 0 0 0 .326.216"
    />
  </svg>
);
export default SvgVolumeMute;
